import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useToast } from "hooks/useToast";
import { useDispatch } from "react-redux";
import { useDeleteTransactionMutation } from "store/apis/transactions";
import { closeSlider } from "store/slices/transactions";
import { BackendError } from "types/utils/error";
import { ModalProps } from "types/utils/modal";

export const DeleteJournalEntry = ({
  close,
  isOpen,
  transactionId,
  ledgerEntryId,
}: ModalProps & {
  transactionId: string;
  ledgerEntryId?: string;
}) => {
  const { alertToast, successToast } = useToast();
  const { uuid: groupId } = useCurrentGroupContext();
  const dispatch = useDispatch();
  const entityId = useCurrentEntityId();
  const [deleteTransaction, { isLoading: isTransactionDeleting }] =
    useDeleteTransactionMutation();

  const onTransactionDelete = async () => {
    try {
      await deleteTransaction({
        entityId,
        groupId,
        transactionId,
      }).unwrap();
      close();
      dispatch(closeSlider(transactionId));
      successToast({ message: "Journal Entry deleted!" });
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Are you sure?</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body className="t-text-text-30 t-text-subtext">
          This ledger transaction is part of a journal entry. Deleting it will
          delete the entire journal entry including all its line items.
          <br />
          Are you sure you want to continue?
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Button onClick={close}>Cancel</Button>
          <Button
            customType="danger"
            isLoading={isTransactionDeleting}
            disabled={isTransactionDeleting}
            onClick={() => onTransactionDelete()}
          >
            Delete journal entry
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
